import React, {useEffect, useState} from "react";
import {ApiService} from "../api/ApiService";
import {TrainingReportGet2} from "../api/model/TrainingReportGet2";
import {CloseIcon} from "../components/icons";

export interface Report {
    trainerCode: string,
    roadTest: any,
    courseId: number,
    courseDay: number,
    backingScore: number,
    turningScore: number,
    roadHabitsScore: number,
    cityScore: number,
    highwayScore: number,
    tabletScore: number,
    hosScore: number,
    defensiveScore: number,
    overallScore: number,
    dmCode: string,
}

const SCORE_ROWS: Array<{label: string, key: keyof Report}> = [
    {label: 'Backing', key: 'backingScore'},
    {label: 'Turning', key: 'turningScore'},
    {label: 'Driving Habits', key: 'roadHabitsScore'},
    {label: 'City Driving', key: 'cityScore'},
    {label: 'Highway Driving', key: 'highwayScore'},
    {label: 'Tablet', key: 'tabletScore'},
    {label: 'Service Hours', key: 'hosScore'},
    {label: 'Defensive Driving', key: 'defensiveScore'},
];

function formatReportDate(raw: string): string {
    const d = new Date(raw.includes('T') || raw.includes('-') ? raw : raw.replace(' ', 'T'));
    if (isNaN(d.getTime())) return raw;
    return d.toLocaleDateString(undefined, {weekday: 'short', month: 'short', day: 'numeric', year: 'numeric'});
}

const ReportDetail = (props: {traineeCode: string, date: string, onClose: () => void}) => {
    const [report, setReport] = useState<Report | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        setLoading(true);
        setError(false);
        ApiService.getTrainingReport2('reportDetail', {traineeCode: props.traineeCode, timeSubmitted: props.date}).then(it => {
            parseReport(it);
        }).catch(() => {
            setError(true);
        }).finally(() => setLoading(false));
    }, [props.traineeCode, props.date]);

    const parseReport = (reportObj: TrainingReportGet2) => {
        let tempObj: any = reportObj
        let tempReportData: any = JSON.parse(reportObj.reportData)
        Object.keys(tempReportData).forEach((element: any) => {
            tempObj[element] = tempReportData[element]
        });
        setReport(tempObj)
    }

    return (
        <div className="design-a">
            <div className="training-modal training-report-modal">
                <div className="training-modal__header">
                    <span>Training Report</span>
                    <button
                        type="button"
                        className="modal-close-btn training-modal__close"
                        onClick={props.onClose}
                        aria-label="Close"
                    >
                        <CloseIcon size={18} color="#1a1a1a" />
                    </button>
                </div>

                <div className="training-report-modal__body">
                    <div className="training-report-modal__date">{formatReportDate(props.date)}</div>

                    {loading ? (
                        <p className="training-report-modal__status">Loading report…</p>
                    ) : error || !report ? (
                        <p className="training-report-modal__status">Unable to load this report. Please try again.</p>
                    ) : (
                        <>
                            <div className="training-course-info training-report-modal__meta">
                                <div className="training-course-info__row">
                                    <span className="training-course-info__label">Trainer</span>
                                    <span className="training-course-info__value">{report.trainerCode}</span>
                                </div>
                                <div className="training-course-info__row">
                                    <span className="training-course-info__label">DM</span>
                                    <span className="training-course-info__value">{report.dmCode && report.dmCode !== 'null' ? report.dmCode : '—'}</span>
                                </div>
                                <div className="training-course-info__row">
                                    <span className="training-course-info__label">Course Day</span>
                                    <span className="training-course-info__value">{report.courseDay}</span>
                                </div>
                                <div className="training-course-info__row">
                                    <span className="training-course-info__label">Road Test</span>
                                    <span className="training-course-info__value">{report.roadTest !== 0 ? 'Yes' : 'No'}</span>
                                </div>
                            </div>

                            <div className="home-section-label">Scores</div>

                            <div className="training-course-info training-report-modal__scores">
                                {SCORE_ROWS.map(row => (
                                    <div className="training-course-info__row" key={row.key}>
                                        <span className="training-course-info__label">{row.label}</span>
                                        <span className="training-course-info__value">{report[row.key] as number}</span>
                                    </div>
                                ))}
                                <div className="training-report-modal__total">
                                    <span className="training-report-modal__total-label">Overall Score</span>
                                    <span className="training-report-modal__total-value">
                                        {report.overallScore}<span className="training-report-modal__total-den">/40</span>
                                    </span>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ReportDetail
